import BulkItemUploadModalSuspense from '../src/BulkItemUploadModalSuspense';
export default BulkItemUploadModalSuspense;
